<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <!--:gotoIndex="gotoIndex"-->
          <headers pageType="blanApply" :areaShow="areaShow" :loginShow="loginShow"  :get-party-id="getPartyId" :reload-page="reloadPage"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a href="javascript:void(0)" @click="urlTo('applyIndex')">个人办事</a>  / <span>养老需求评估</span></p></div>
          </div>
        </div>

        <div class="wraper">
          <!--申报信息 -->
          <div v-show="stepFlag=='apply'" class="deal">
            <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign7.png"> 选择办理方式</span><em></em></h2>
            <dl class="safe_appply" >
              <dd><span class="title"> 办理方式：</span><em>
                <el-select v-model="req_yl_person.apply_way" placeholder="请选择" @change="selectApplyType"  style="width: 80%;margin-right: 5px;" >
                  <el-option
                    v-for="item in way_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select><img src="../../../static/images/required.png"></em></dd>
              <dd style="height: 120px;"  v-if="req_yl_person.apply_way==1"><span class="title"> &nbsp;申请人身份证照： &nbsp;</span>
                <em style="display: flex;justify-content: left;">
                  <div style="width: 190px;margin-right: 10px;">
                    <el-upload
                      class="avatar-uploader"
                      list-type="picture"
                      action=""
                      :file-list="frontFileList"
                      :show-file-list="false"
                      :http-request="afterReadOne"
                      :on-remove="handleRemove"
                    >
                      <img v-if="idcard_pic_front_img" :src="idcard_pic_front_img" class="avatar" style="width:180px;height: 127px;">
                      <img  v-else src="../../../static/images/id_front.png" style="width: 180px;height: 127px;">
                    </el-upload>
                  </div>
                  <div style="width: 190px;">
                    <el-upload
                      class="avatar-uploader"
                      list-type="picture"
                      action=""
                      :file-list="backFileList"
                      :show-file-list="false"
                      :http-request="afterReadTwo"
                      :on-remove="handleRemove"
                    >
                      <img v-if="idcard_pic_back_img" :src="idcard_pic_back_img" class="avatar" style="width:180px;height: 127px;">
                      <img v-else src="../../../static/images/id_back.png" style="width: 180px;height: 127px;">
                    </el-upload>
                  </div>
                </em>
              </dd>
              <dd v-if="isShow"><span class="title"> 申请人姓名：</span><em>

                <el-input v-if="1==person_uid_disable" :readonly="true" v-model="req_yl_person.person_name" placeholder="请输入申请人姓名"  style="width: 80%;margin-right: 5px;"></el-input>
                <el-input v-else v-model="req_yl_person.person_name" placeholder="请输入申请人姓名"  style="width: 80%;margin-right: 5px;"></el-input>

                <img src="../../../static/images/required.png"></em> </dd>
              <dd v-if="isShow"><span class="title"> 申请人身份证：</span><em>

                <el-input v-if="1==person_uid_disable" :readonly="true" v-model="req_yl_person.person_uid" maxlength="18" placeholder="请输入身份证号" style="width: 80%;margin-right: 5px;"></el-input>
                <el-input v-else v-model="req_yl_person.person_uid" maxlength="18" placeholder="请输入身份证号" style="width: 80%;margin-right: 5px;"></el-input>

                <img src="../../../static/images/required.png"></em> </dd>

              <dd v-if="isShow && req_yl_person.apply_way==1"><span class="title"> 委托人姓名：</span><em><el-input v-model="req_yl_person.auth_person_name" maxlength="11" :readonly="true" placeholder="请输入委托人姓名"  style="width: 80%;margin-right: 5px;"></el-input><img src="../../../static/images/required.png"></em> </dd>
              <dd v-if="isShow && req_yl_person.apply_way==1"><span class="title"> 委托人身份证：</span><em><el-input v-model="req_yl_person.auth_person_uid" maxlength="18" :readonly="true" placeholder="请输入紧委托人身份证"  style="width: 80%;margin-right: 5px;"></el-input><img src="../../../static/images/required.png"></em> </dd>
              <dd v-if="isShow && req_yl_person.apply_way==1"><span class="title"> 委托人电话：</span><em><el-input v-model="req_yl_person.auth_tel" maxlength="11" :readonly="true" placeholder="请输入委托人电话"  style="width: 80%;margin-right: 5px;"></el-input><img src="../../../static/images/required.png"></em> </dd>
              <dd  v-if="isShow"><span class="title"> 户籍区划：</span><em><el-cascader  ref="cs2"  v-model="selectedRegion" :props="props"  :show-all-levels="false" placeholder="请选择户籍区划" style="width: 80%;margin-right: 5px;" ></el-cascader><img src="../../../static/images/required.png"></em></dd>
              <dd v-if="qxAlertFlag" style="margin-top: 0px;"><span class="title">&nbsp; </span><em style="line-height: 30px;"><div v-if="qxAlertFlag" style="width:80%;line-height: 30px;" class="alert_f_css">
                <el-alert
                  :closable="false"
                  :title="alertMsg"
                  :type="alertType"
                  show-icon>
                </el-alert>
              </div></em></dd>
              <dd style="text-align: center;padding-top: 20px;">

                <el-button type="primary"  :disabled="canNext" @click="applyNextStep" style="padding-left:30px;padding-right: 25px;">下一步</el-button>
              </dd>
            </dl>
          </div>


          <div v-show="stepFlag !='apply'"  class="advice">
            <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign12.png">{{title_info}}</span><em><img src="../../../static/images/required.png"> 为必填项</em></h2>
            <div class="advance_infor" style="padding-top: 5px;">
              <div style="width: 80%;margin: 0 auto;">
                <el-steps :active="stepactive" finish-status="success" simple style="margin-top: 20px">
                  <el-step title="基本信息" ></el-step>
                  <el-step title="完成" ></el-step>
                </el-steps></div></div>
            <!--申请人信息begin-->

            <el-form  :rules="reqManInfo_rules" :model="req_yl_person" label-width="140px" ref="reqManInfo_ruleForm" class="demo-ruleForm">
              <table v-show="stepFlag=='reqManInfo'" width="80%" border="0" cellspacing="0" cellpadding="0" class="advice_tab_new22" style="padding-top:15px;margin: 0 auto;">
                <tr>
                  <td colspan="3"><h2 class="information_tit">基本信息</h2></td>
                </tr>
                <tr>
                  <td width="45%">
                    <el-form-item  label="姓 名：" prop="person_name">
                      <el-input v-model="req_yl_person.person_name" :readonly="true" placeholder="请输入申请人姓名"  style="width: 250px;" ></el-input>
                    </el-form-item>
                  </td>
                  <td width="4%">&nbsp;</td>
                  <td width="40%">
                    <el-form-item  label="身份证号：" prop="person_uid">
                      <el-input v-model="req_yl_person.person_uid" :readonly="true"  placeholder="请输入身份证号"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td >
                    <el-form-item  label="性 别：" prop="person_sex">
                      <el-select
                        v-model="req_yl_person.person_sex"
                        collapse-tags :disabled="true"
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          label="男"
                          value="1">
                        </el-option>
                        <el-option
                          label="女"
                          value="0">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td>&nbsp;</td>
                  <td>
                    <el-form-item  label="年 龄：" prop="person_age">
                      <el-input v-model="req_yl_person.person_age" :readonly="true"  placeholder="请输入年龄"  style="width: 250px;"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item  label="民 族：" prop="nations_type_id">
                      <el-select
                        v-model="req_yl_person.nations_type_id"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in nations_type"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td>&nbsp;</td>
                  <td>
                    <el-form-item  label="身份类别：" prop="person_type_id">
                      <el-select
                        v-model="req_yl_person.person_type_id"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in person_types"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item  label="文化程度：" prop="education">
                      <el-select
                        v-model="req_yl_person.education"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in education_levels"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td>&nbsp;</td>
                  <td>
                    <el-form-item  label="婚姻状况：" prop="marital">
                      <el-select
                        v-model="req_yl_person.marital"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in marital_status"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <!--<td>
                    <el-form-item  label="管理单位：" prop="gl_party_id">
                      <em><el-cascader  ref="cs2"  v-model="selectedRegion2" :props="props"  :show-all-levels="false" placeholder="请选择管理单位" style="width: 250px;margin-right: 5px;" ></el-cascader></em>
                    </el-form-item>
                  </td>-->
                  <td> <el-form-item  label="联系电话：" prop="mobile">
                    <el-input v-model="req_yl_person.mobile" maxlength="11"  @change="mobileChange" placeholder="请输入联系电话"  style="width: 250px;"></el-input>
                  </el-form-item></td>
                  <td>&nbsp;</td>
                  <td> </td>
                </tr>

                <tr>
                  <td colspan="3">
                    <el-form-item  label="户籍地址：" prop="regi_address">
                      <el-input v-model="req_yl_person.regi_address" placeholder="请输入户籍地址"  style="width: 715px;"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <el-form-item  label="居住地址：" prop="living_address">
                      <el-input v-model="req_yl_person.living_address" placeholder="请输入居住地址"  style="width: 715px;"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td colspan="3"><h2 class="information_tit">健康、申请信息</h2></td>
                </tr>
                <tr>
                  <td width="45%">
                    <el-form-item  label="健康状况：" prop="health">
                      <el-select
                        v-model="req_yl_person.health"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in health"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td width="4%">&nbsp;</td>
                  <td width="40%">
                    <el-form-item  label="慢性疾病：" prop="chronic_disease">
                      <el-select
                        v-model="req_yl_person.chronic_disease"
                        multiple
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in chronic_disease"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td width="45%">
                    <el-form-item  label="重大疾病：" prop="major_diseases">
                      <el-select
                        v-model="req_yl_person.major_diseases"
                        collapse-tags
                        multiple
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in major_diseases"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td width="4%">&nbsp;</td>
                  <td width="40%">
                    <el-form-item  label="痴呆：" prop="dementia_status">
                      <el-select
                        v-model="req_yl_person.dementia_status"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in dementia_status"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td width="45%">
                    <el-form-item  label="精神疾病：" prop="mental_illness">
                      <el-select
                        v-model="req_yl_person.mental_illness"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in mental_illness"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td width="4%">&nbsp;</td>
                  <td width="40%">
                    <el-form-item  label="医疗支付方式：" prop="medical_payment">
                      <el-select
                        v-model="req_yl_person.medical_payment"
                        collapse-tags
                        placeholder="请选择" style="width: 250px;">
                        <el-option
                          v-for="item in medical_payment"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td width="45%" colspan="3">
                    <el-form-item  label="服务需求：" prop="service_demand_type">
                      <el-radio @change="detailShow('jjyl')" v-model="req_yl_person.service_demand_type" label="1">居家养老</el-radio>
                      <el-radio @change="detailShow('jgyl')" v-model="req_yl_person.service_demand_type" label="2">机构养老</el-radio>
                    </el-form-item>
                  </td>
                </tr>
                <tr  v-if="jjyl">
                  <td width="45%" colspan="3">
                    <el-form-item  >
                      <el-checkbox-group v-model="req_yl_person.service_demand" >
                          <el-checkbox v-for="(item,index) in home_care_service" :key="index+'12312'" :label="item.id">{{item.name}}</el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </td>
                </tr>
                <tr  v-if="jgyl">
                  <td width="45%" colspan="3">
                    <el-form-item  >
                      <el-checkbox-group v-model="req_yl_person.service_demand" >
                          <el-checkbox v-for="(item,index) in org_care_service" :key="index+'1212'" :label="item.id">{{item.name}}</el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </td>
                </tr>
                <td colspan="3">
                  <el-form-item  label="申请原因："  >
                    <el-input
                      type="textarea" maxlength="200"
                      :rows="3"
                      placeholder="请输入申请原因"
                      v-model="req_yl_person.req_reason" style="width: 100%;">
                    </el-input>
                  </el-form-item>
                </td>
                <tr>
                  <td colspan="3"  style="height: 50px;line-height: 50px;text-align: center;padding-top: 10px;">
                    <el-button  @click="upStep('apply',0,'提交基本信息')" style="padding-left:30px;padding-right: 25px;">上一步</el-button>
                    <el-button  type="primary"   @click="onSave" style="padding-left:30px;padding-right: 25px;" >保存</el-button>
                    <el-button  type="primary"  @click="onSubmit" style="padding-left:30px;padding-right: 25px;" v-if="canEditBoolean">提交</el-button>
                    <!--                    &lt;!&ndash;<el-button  type="primary"  @click="infoNext('materialinfo',1,'上传资料')" style="padding-left:30px;padding-right: 25px;">&ndash;&gt;下一步</el-button>-->
                  </td>
                </tr>
              </table>
            </el-form>
          </div>

        </div>
      </div>
    </div>

    <el-dialog
      title="实名认证提示"
      :visible.sync="smDialogShow"
      width="400px"
      :before-close="handleClose">
      <span>根据政策规定，在线申办业务，需要实名认证！请选择：<br />1、点击【确定】跳转到实名认证页面<br />2、点击【取消】返回上一级页面</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="sureClose">确 定</el-button>
  </span>
    </el-dialog>

    <div class="clear"></div>
    <footers></footers>

  </div>
</template>
<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  import imgUploader from "../../components/ImgUploader";
  import imgUploaderOne from "../../components/ImgUploaderOne";
  export default {
    inject:['reload'],
    name: "public-index",
    components:{
      headers,fixedDiv,footers,imgUploader,imgUploaderOne
    },
    data() {
      let _self=this;
      return {
        party_temp:[],
        slPartIdArr:[],
        checkList: [],
        home_care_service: [],
        org_care_service: [],
        person_types: [],
        disease: [],
        chronic_disease: [],
        major_diseases: [],
        medical_payment: [],
        mental_illness: [],
        dementia_status: [],
        person_class: [],
        person_uid_disable:1,
        is_submit:false,
        jjyl:false,
        jgyl:false,
        title_info:'',
        familyUserDialog:false,
        stepFlag:'apply',//apply申请也 familyInfo家庭页,master申请人\
        idcard_pic_frontArr:[],
        idcard_pic_backArr:[],
        stepactive:0,
        qxAlertFlag:false,
        alertMsg:'',
        alertType:'',
        smDialogShow:false,
        width:document.body.clientWidth+'px',
        height:document.body.clientHeight+'px',
        apply_id:'',
        canNext:true,
        preInit:false,
        editFlag:false,
        party_id:'',
        nav_name:'养老需求评估',
        nav_name_apply:'',
        service_code:'',
        dataObjList:[],
        areaShow:false,
        loginShow:false,
        gotoIndex:false,
        canEditBoolean:true,
        disCan:true,
        addCan:false,
        delCan:false,
        reloadFlag:false,
        selectedRegion:[],
        selectedRegion2:[],
        selecteddepartOption:[],
        departOption:[],
        enjoy_treat:'无',
        first_area_id:'',
        props: {  lazy: true,
          checkStrictly:false,
          lazyLoad (node, resolve) { const { level } = node;
            var t=0;
            if(!node.value){
              // node.value=_self.$cookies.get("areaRoot");
              //得到区划配置中的市级
              node.value=_self.first_area_id;
              t=1;
              //上级为空，默认设置大通县数据
            }
            const options={pid:node.value}
            _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
              const nodes =[];
              // if(t==0) {
              if (response.status === 200 && response.data.code === 200) {
                const nodes = Object.values(response.data.data).map(function (e) {
                  return {label: e.name, value: e.code, level: 0, leaf: level >= 2}
                })
                resolve(nodes);
              } else {
                resolve(nodes);
              }
              // }else{
              //   const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
              //   resolve(nodes);
              // }
            })
          }
        },
        way_options:[
          {
            value:0,
            label:'本人办理'
          },{
            value:1,
            label:'委托办理'
          }
        ],
        reqManInfo_rules:{
          'service_demand_type':[{required:true,message:'请选择服务需求',tigger:'blur'}],
          'health':[{required:true,message:'请选择健康状况',tigger:'blur'}],
          'dementia_status':[{required:true,message:'请选择痴呆状况',tigger:'blur'}],
          'mental_illness':[{required:true,message:'请选择精神状况',tigger:'blur'}],
          'medical_payment':[{required:true,message:'请选择医疗支付方式',tigger:'blur'}],
          'chronic_disease':[{type: 'array',required:true,message:'请选择慢性疾病',tigger:'change'}],
          'major_diseases':[{type: 'array',required:true,message:'请选择重大疾病',tigger:'change'}],
          'service_demand':[{required:true,message:'请选择服务需求',tigger:'blur'}],
          'education':[{required:true,message:'请选择文化程度',tigger:'blur'}],
          'marital':[{required:true,message:'请选择婚姻状况',tigger:'blur'}],
          'gl_party_id':[{required:true,message:'请选择管理单位',tigger:'blur'}],
          'eq_reason':[{required:true,message:'请输入申请理由',tigger:'blur'}],
          'person_name':[{required:true,message:'请输入申请人姓名',tigger:'blur'}],
          'req_person_name':[{required:true,message:'请输入申请人姓名',tigger:'blur'}],
          'person_uid':[{required:true,validator:this.checkUid,tigger:'blur'}],
          'req_person_uid':[{required:true,validator:this.checkUid,tigger:'blur'}],
          'person_sex':[{required:true,message:'请选择性别',tigger:'change'}],
          'person_birthday':[{required:true,message:'请选择出生日期',tigger:'blur'}],
          'person_age':[{required:true,message:'请输入年龄',tigger:'blur'},
            {required:true,pattern:/^(([0-9]|[1-9][0-9]|1[0-7][0-9])(\\.[0-9]+)?|180)$/,message:'请输入正确的年龄',tigger:'blur'}],
          'nations_type_id':[{required:true,message:'请选择民族',tigger:'change'}],
          'regi_kind':[{required:true,message:'请选择户口性质',tigger:'change'}],
          'regi_address':[{required:true,message:'请输入户籍地址',tigger:'blur'}],
          'living_address':[{required:true,message:'请输入居住地址',tigger:'blur'}],
          'req_addr':[{required:true,message:'请输入居住地址',tigger:'blur'}],


          'viability_id':[{required:true,message:'请选择自理能力',tigger:'change'}],
          'soical_ins_number':[{required:true,message:'请输入社会保障号',tigger:'blur'}],
          'mobile':[{required:true,message:'请输入联系电话',tigger:'blur'},{required:true,pattern:/^[1][3,4,5,6,7,8,9][0-9]{9}$/,message:'请输入正确的手机号码',tigger:'blur'}],
          'req_tel':[{required:true,message:'请输入联系电话',tigger:'blur'},{required:true,pattern:/^[1][3,4,5,6,7,8,9][0-9]{9}$/,message:'请输入正确的手机号码',tigger:'blur'}],

          'bank_relation_id':[{required:true,message:'请选择与本人关系',tigger:'change'}],
          'bank_person_uid':[{required:true,validator:this.checkUid,tigger:'blur'}],

   },
        photos:[],
        personType:[],
        azType:[],
        idcardPic:[],
        initFlag:0,
        ylNeedDetail:{},
        blanApply:{
          archive_type_code:'',
          nav_name:'',
          canEdit:true,


          photos:[]
        },//包含baseeInfo(申报基本信息）
        req_yl_person:{
          person_name:"",
          apply_id:"",
          gl_party_id:"",
          person_uid:"",
          apply_way:0,
          apply_date:"",
          apply_source:"2",
          apply_status:"",
          to_party_id:"",
          handle_time:"",
          handle_user_id:"",
          handle_party_id:"",
          apply_desc:"",
          req_reason:"",
          referral:"",
          trans_log_id:"",
          p_user_id:"",
          auth_person_uid:"",
          auth_person_name:"",
          auth_tel:"",
          mobile:"",
          person_sex:"",
          person_birthday:"",
          person_age:"",
          nations_type_id:"",
          person_type_id:"",
          education:"",
          marital:"",
          city_id:"",
          county_id:"",
          towns_id:"",
          party_id:"",
          regi_address:"",
          living_address:"",
          photo_id:"",
          idcard_pic_front:"",
          idcard_pic_back:"",
          health:"",
          dementia_status:"",
          mental_illness:"",
          medical_payment:"",
          chronic_disease:[],
          major_diseases:[],
          service_demand_type:"",
          service_demand:[],
          data_state:"",


        },
        idcard_pic_front:'',
        idcard_pic_front_img:'',
        idcard_pic_back:'',
        idcard_pic_back_img:'',


        idcard_pic_front_jf:'',
        idcard_pic_front_img_jf:'',
        idcard_pic_back_jf:'',
        idcard_pic_back_img_jf:'',


        isShow:true,
        apply_way:0,
        loginPerson:{
          person_name:'',
          person_uid:'',
          person_tel:'',
          isCertification:'',
          idcardPicFront:'',
          idcardPicBack:'',
          userIdcardAddress:'',
          userNationsId:'',
          userNations:'',
          photo_id:'',
        },
        frontFileList:[],
        backFileList:[],
        fmfrontFileList:[],
        fmbackFileList:[],
        housing_type:[],
        house_type:[],
        proverty_causes:[],
        help_type:[],
        bank_type:[],
        bank_card_type:[],
        open_document_type:[],
        nations_type:[],relation:[],marital_status:[],political_status:[],regi_kind:[],
        education_levels:[],work_capacity:[],party_nature_type:[],health:[],serious_name:[],
        person_type:[],dis_type:[],dis_level:[],viability:[],
        is_blan_type:[
          {name:'是',id:'1'},
          {name:'否',id:'0'},
        ],
        is_guardian_person_type:[
          {name:'有',id:1},
          {name:'无',id:0},
        ],
        blan_type:[
          {name:'无',id:'0'},
          {name:'城市低保',id:'blan_city'},
          {name:'农村低保',id:'blan_side'}
        ],
        archive_type_code:'',

        guardianShow:false,
        temp_guardian_id:'',
        temp_guardian:{
          guardian_person_name:'',
          guardian_person_uid:'',
          guardian_phone:'',
          guardian_idcard_pic_front:'',
          guardian_idcard_pic_back:'',
          idcard_pic_back_img_jf:'',
          idcard_pic_front_img_jf:'',
          idcard_pic_front_jf:'',
          idcard_pic_back_jf:'',
        },
        bankRelationTemp:'',
        bankRelationTempArr:{
          bank_person_uid:'',
          bank_account_name:''
        },
        loadImg:false,
        jhrFlag:false,//监护人是否显示
        cjFlag:false,//残疾显示
        panel:'',
      }
    } ,
    watch: {
      width(n,o){
        alert(n+'w')
      },
      height(n,o){
        alert(n+'h')
      },

      'req_yl_person.dis_info'(n,o){
        if(!this.disCan){
          if(this.req_yl_person.dis_info){
            var length=this.req_yl_person.dis_info.length;
            if(length<=2){
              this.addCan=true;
              this.delCan=false;
            }else{
              this.addCan=true;
              this.delCan=true;
            }
          }else{
            this.addCan=true;
            this.delCan=false;
          }
        }else{
          this.addCan=false;
          this.delCan=false;
        }

      },
      selectedRegion(nv){
        if(nv && nv.length>2) {
          this.req_yl_person.to_party_id = nv[nv.length - 2];
          this.req_yl_person.party_id = nv[nv.length - 1];
          this.slPartIdArr=nv;
          this.qxAlertFlag=false;
          this.alertMsg='';
          this.alertType="";
        } else{
          // this.req_yl_person.to_party_id='';
          this.req_yl_person.party_id='';
          this.slPartIdArr=[];
        }
      },
      selectedRegion2(nv){
        if(nv && nv.length>0) {
          this.party_temp=nv;
          this.req_yl_person.gl_party_id = nv[nv.length - 1];
        }
        else{
          this.req_yl_person.gl_party_id='';
        }
      },
      'req_yl_person.person_uid'(n,o){
        if(n && (n.length==18||n.length==15)) {
          if(this.$util.uid.validatorUid(n)){
            this.canNext=true;
            this.req_yl_person.person_uid = n;
            this.req_yl_person.relation_id = "29031";
            this.req_yl_person.relation_name = "本人";
            this.req_yl_person.soical_ins_number = n;
            if (this.req_yl_person.bank_relation_id == '29031') {
              this.req_yl_person.bank_person_uid = n;
            }
            // this.loadEnjoyTreat();
            this.initPre();
          }
        }
        if (this.$util.uid.validatorUid(n)){
          let age = this.$util.uid.getAgeByUid(n);
          let uidInfo=this.$util.uid.parse_person_uid(n)
          this.req_yl_person.person_age = age+'';
          this.req_yl_person.person_birthday=uidInfo.birthday;
          this.req_yl_person.person_sex=uidInfo.sex;
        }
      },
      'req_yl_person.person_name'(n,o){
        this.req_yl_person.person_name=n;
        if(this.req_yl_person.bank_relation_id =='29031' && !this.preInit){
          this.req_yl_person.bank_account_name=n;
        }
      },
      'req_yl_person.user_nations_id'(n,o){
        if(this.req_yl_person.user_nations_id && this.req_yl_person.user_nations_id!=''){
          this.req_yl_person.nations_type_id=this.req_yl_person.nations_type_id;
          this.req_yl_person.nations_type_name=this.req_yl_person.nations_type_name;
        }
      },
      'req_yl_person.user_idcard_address'(n,o){
        if(this.req_yl_person.user_idcard_address && this.req_yl_person.user_idcard_address!=''){
          this.req_yl_person.regi_address=this.req_yl_person.user_idcard_address;
          this.req_yl_person.living_address=this.req_yl_person.user_idcard_address;
        }
      },

    },
    created(){
      var areaInfo = this.$cookies.get('areaInfo')
      if (areaInfo && areaInfo.departyId && areaInfo.departyId.length>0) {
        this.first_area_id=areaInfo.departyId[0];
      }else{
        this.first_area_id='63010001'
      }
      //判断是否登录没有，没登录的话，要求必须登录
      var _apply_id=this.$route.query.apply_id;
      if(_apply_id!=null && _apply_id!=''&& _apply_id!=undefined) {
        this.apply_id = _apply_id;
        this.editFlag=true;
        this.showApply(this.apply_id);
      }
      this.archive_type_code=this.$route.query.archive_type_code;

      if(this.$route.query.canEdit==false || this.$route.query.canEdit=="false"){
        this.canEditBoolean=false;
      }
      // this.canEditBoolean=true;
      this.blanApply.archive_type_code=this.archive_type_code;
      this.blanApply.canEdit=this.canEditBoolean;

      // this.initPhoneArr();
      this.getDictData();
      /*    this.getBankTypeData();*/

    },
    mounted(){
      //获取applyId;
      var userInfo=this.$cookies.get('userInfo')
      if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
        this.loginShow=true;
        this.gotoIndex=true;
        return;
      }else {

        this.loadPersonInfo();
      }


    },
    methods: {
      initPre(){
        if(this.editFlag){
          //如果是修改操作，不加载数据
          this.canNext=false;
          return;
        }
        this.preInit=true;
        //根据身份证预加载数据
        var tt=this;
        this.$https.post("api/ywt/apply/getPreFillInfoYl.do",{person_uid:this.req_yl_person.person_uid},(responsesss)=>{
          if (responsesss.data.code==200 && responsesss.data.data){
            // console.log(responsesss.data.data);
            var data=responsesss.data.data;

            if(tt.$util.notEmpty(data.person_name)){
              tt.req_yl_person.person_name=data.person_name;
            }
            if(tt.$util.notEmpty(data.nationsTypeId)){
              if(tt.$util.notEmpty(data.nationsTypeName)){
                tt.req_yl_person.user_nations=data.nationsTypeName;
              }
              tt.req_yl_person.user_nations_id=data.nationsTypeId;
            }
            if(tt.$util.notEmpty(data.regiAddress)){
              tt.req_yl_person.user_idcard_address=data.regiAddress;
            }
            if(tt.$util.notEmpty(data.partyId)){
              tt.req_yl_person.party_id=data.partyId;
            }
            if(tt.$util.notEmpty(data.photoId)){
              tt.req_yl_person.photo_id=data.photoId;
            }
            if(tt.$util.notEmpty(data.mobile)){
              tt.req_yl_person.mobile=data.mobile;
            }else{
              if(tt.req_yl_person.apply_way==1){
                tt.req_yl_person.mobile='';
              }
            }
            if(tt.$util.notEmpty(data.bankRelationId)){
              tt.req_yl_person.bank_relation_id=data.bankRelationId
              if(tt.$util.notEmpty(data.bankRelationName)){
                tt.req_yl_person.bank_relation_name=data.bankRelationName
              }
            }else{
              // if(tt.req_yl_person.apply_way==1) {
              tt.req_yl_person.bank_relation_id = '29031'
              tt.req_yl_person.bank_relation_name = '本人'
              // }
            }
            if(tt.$util.notEmpty(data.bankTypeId)){
              tt.req_yl_person.bank_type_id=data.bankTypeId
              if(tt.$util.notEmpty(data.bankTypeName)){
                tt.req_yl_person.bank_name=data.bankTypeName
              }
            }else{
              // if(tt.req_yl_person.apply_way==1) {
              tt.req_yl_person.bank_type_id= ''
              tt.req_yl_person.bank_name = ''
              // }
            }
            if(tt.$util.notEmpty(data.bankAccountCode)){
              tt.req_yl_person.bank_account_code=data.bankAccountCode
            }else{
              if(tt.req_yl_person.apply_way==1) {
                tt.req_yl_person.bank_account_code=''
              }
            }
            if(tt.$util.notEmpty(data.bankAccountName)){
              tt.req_yl_person.bank_account_name=data.bankAccountName
            }else{
              // if(tt.req_yl_person.apply_way==1) {
              tt.req_yl_person.bank_account_name=tt.req_yl_person.person_name
              // }
            }
            if(tt.$util.notEmpty(data.bankPersonUid)){
              tt.req_yl_person.bank_person_uid=data.bankPersonUid
            }else{
              // if(tt.req_yl_person.apply_way==1) {
              tt.req_yl_person.bank_person_uid=tt.req_yl_person.person_uid
              // }
            }
            if(tt.$util.notEmpty(data.dis_num)){
              tt.req_yl_person.disability_number=data.dis_num
              if(data.disList && data.disList.length>0){
                tt.req_yl_person.dis_info=data.disList
              }
            }else{
              tt.req_yl_person.disability_number=''
              tt.req_yl_person.dis_info=[]
            }
            if(tt.$util.notEmpty(data.soicalInsNumber)){
              tt.req_yl_person.soical_ins_number=data.soicalInsNumber
            }else{
              tt.req_yl_person.soical_ins_number=''
            }
            if(tt.$util.notEmpty(data.bankCardType)){
              tt.req_yl_person.bank_card_type=data.bankCardType
              if(tt.$util.notEmpty(data.bankCardTypeName)){
                tt.req_yl_person.bank_card_type_name=data.bankCardTypeName
              }
            }else{
              tt.req_yl_person.bank_card_type='26100'
              tt.req_yl_person.bank_card_type_name='银行卡'
            }
            if(tt.$util.notEmpty(data.openDocumentType)){
              tt.req_yl_person.open_document_type=data.openDocumentType
              if(tt.$util.notEmpty(data.openDocumentTypeName)){
                tt.req_yl_person.open_document_type_name=data.openDocumentTypeName
              }
            }else{
              tt.req_yl_person.open_document_type='28931'
              tt.req_yl_person.open_document_type_name='身份证'
            }
          }

          tt.preInit=false;
          tt.initAreaFromAddress(tt.req_yl_person.user_idcard_address);
        });
      },
      showApply(applyId){
        let options={
          apply_id: applyId,
        }
        this.$https.post("api/ywt/apply/getYlApplyDetail.do",options,(response)=>{

          if (response.data.code!==200){
            // tttt.$toast.fail(response.data.msg)
          }else {
            // this.req_yl_person={};
            // this.ylNeedDetail={};
            this.ylNeedDetail=response.data.data;
            if (1==this.ylNeedDetail.serviceDemandType){
              this.jjyl=true
            }else if (2==this.ylNeedDetail.serviceDemandType){
              this.jgyl=true
            }
            this.req_yl_person.apply_way=this.ylNeedDetail.applyWay;
            if (0==this.req_yl_person.apply_way){
              //本人办理
              this.idcard_pic_front=this.ylNeedDetail.idcardPicFront
              this.idcard_pic_back= this.ylNeedDetail.idcardPicBack
            }else {
              //委托办理需要读取身份证图片，稍后
              this.idcard_pic_front=this.ylNeedDetail.idcardPicFront;
              this.idcard_pic_back=this.ylNeedDetail.idcardPicBack;

              this.req_yl_person.idcard_pic_front=this.ylNeedDetail.idcardPicFront;
              this.req_yl_person.idcard_pic_back=this.ylNeedDetail.idcardPicBack;
              this.idcard_pic_frontArr=[];
              this.idcard_pic_frontArr.push(this.ylNeedDetail.idcardPicFront);
              this.idcard_pic_backArr=[];
              this.idcard_pic_backArr.push(this.ylNeedDetail.idcardPicBack);
              this.idcard_pic_front_jf=this.ylNeedDetail.idcardPicFront;
              this.idcard_pic_back_jf=this.ylNeedDetail.idcardPicBack;
              if(this.idcard_pic_front && this.idcard_pic_front!=''){
                var imgUrl=this.getImg(this.idcard_pic_front);
                this.idcard_pic_front_img=imgUrl;
              }
              if(this.idcard_pic_back && this.idcard_pic_back!=''){
                var imgUrl=this.getImg(this.idcard_pic_back);
                this.idcard_pic_back_img=imgUrl;
              }
              this.req_yl_person.auth_person_name=this.ylNeedDetail.authPersonName
              this.req_yl_person.auth_person_uid=this.ylNeedDetail.authPersonUid
              this.req_yl_person.auth_tel=this.ylNeedDetail.authTel
            }
            this.req_yl_person.apply_id=this.ylNeedDetail.applyId;
            this.req_yl_person.apply_way_name=this.ylNeedDetail.applyWayName;
            this.req_yl_person.apply_no=this.ylNeedDetail.applyNo;
            this.req_yl_person.person_name=this.ylNeedDetail.personName;
            this.req_yl_person.person_uid=this.ylNeedDetail.personUid;
            this.req_yl_person.nations_type_id=this.ylNeedDetail.nationsTypeId;
            this.req_yl_person.nations_type_name=this.ylNeedDetail.nationsTypeIdName;
            this.req_yl_person.person_type_id=this.ylNeedDetail.personTypeId;
            this.req_yl_person.person_type_name=this.ylNeedDetail.personTypeIdName;
            this.req_yl_person.education=this.ylNeedDetail.education;
            this.req_yl_person.education_levels_name=this.ylNeedDetail.educationName;
            this.req_yl_person.marital=this.ylNeedDetail.marital;
            this.req_yl_person.marital_name=this.ylNeedDetail.maritalName;
            this.req_yl_person.mobile=this.ylNeedDetail.mobile;
            this.req_yl_person.regi_address=this.ylNeedDetail.regiAddress;
            this.req_yl_person.living_address=this.ylNeedDetail.livingAddress;
            this.req_yl_person.dementia_status=this.ylNeedDetail.dementiaStatus;
            this.req_yl_person.dementia_status_name=this.ylNeedDetail.dementiaStatusName;
            this.req_yl_person.mental_illness=this.ylNeedDetail.mentalIllness;
            this.req_yl_person.mental_illness_name=this.ylNeedDetail.mentalIllnessName;
            this.req_yl_person.medical_payment=this.ylNeedDetail.medicalPayment;
            this.req_yl_person.medical_payment_name=this.ylNeedDetail.medicalPaymentName;
            this.req_yl_person.health=this.ylNeedDetail.health;
            this.req_yl_person.health_name=this.ylNeedDetail.healthName;
            this.req_yl_person.req_reason=this.ylNeedDetail.reqReason;
            this.req_yl_person.service_demand_type=this.ylNeedDetail.serviceDemandType;
            /*this.req_yl_person.service_demand_type='1';//response.data.data.serviceDemandType*/
            this.req_yl_person.chronic_disease=this.ylNeedDetail.chronicDisease;
            this.req_yl_person.major_diseases=this.ylNeedDetail.majorDiseases;
            this.req_yl_person.service_demand=this.ylNeedDetail.serviceDemand;
            this.req_yl_person.party_id=this.ylNeedDetail.partyId;
            this.req_yl_person.to_party_id=this.ylNeedDetail.toPartyId;
            this.party_ids(this.ylNeedDetail.partyId)
            /*   this.req_yl_person.service_demand=array.map(this.ylNeedDetail.serviceDemand);

               if (this.ylNeedDetail.partyId!==""){
                 this.req_yl_person.to_party_id=this.ylNeedDetail.partyId;

                 this.workDepartIdNew=this.ylNeedDetail.partyId;
                 this.workDepartId=this.ylNeedDetail.partyId;
                 this.req_yl_person.to_party_name=this.ylNeedDetail.partyIdName

     /!*
                 this.ylPartyArr[0]=this.ylNeedDetail.county_id;
                 this.ylPartyArr[1]=this.ylNeedDetail.towns_id;
                 this.ylPartyArr[2]=this.ylNeedDetail.partyId;*!/

               }*/

          }
        });

      },
      initAreaFromAddress(address){
        if(address && address!=''){
          var tt=this;
          this.$https.post("api/ywt/base/transAddrToParty.do",{addr:address},(response)=>{
            if (response.data.code==200 && response.data.data && response.data.data.partyId){
              // tttt.workDepartIdNew=response.data.data.partyId
              // tttt.workDepartId=response.data.data.partyId
              // tttt.baseInfo.to_party_id=response.data.data.partyId;
              // tttt.$store.state.clpApply.clpInfo.party_id=response.data.data.partyId;
              var dd=response.data.data.partyIdAddr;
              tt.first_area_id=dd[0];
              dd.splice(0,1);
              tt.selectedRegion=dd;
              if(dd.length>2){
              tt.req_yl_person.to_party_id=tt.selectedRegion[dd.length-2];
              tt.req_yl_person.party_id=response.data.data.partyId;
              }
              let cs=tt.$refs['cs2'];
              cs.panel.activePath=[];
              cs.panel.loadCount=0;
              cs.panel.lazyLoad();
              tt.canNext=false;
            }else{
              var areaInfo = tt.$cookies.get('areaInfo')
              if (areaInfo && areaInfo.departyId && areaInfo.departyId.length>0) {
                tt.first_area_id=areaInfo.departyId[0];
                areaInfo.departyId.splice(0,1);
                tt.selectedRegion=areaInfo.departyId;
                if(areaInfo.departyId.length>2){
                tt.req_yl_person.to_party_id=areaInfo.departyId[areaInfo.departyId.length-2];
                tt.req_yl_person.party_id=areaInfo.departyId[areaInfo.departyId.length-1];
                }
                let cs=tt.$refs['cs2'];
                cs.panel.activePath=[];
                cs.panel.loadCount=0;
                cs.panel.lazyLoad();
                tt.canNext=false;
              }else{
                tt.areaShow = true;
              }
            }
          });
        }else{
          this.canNext=false;
        }
      },
      mobileChange(v){
        this.req_yl_person.mobile=v;
      },


      checkUid(rule,value,callback){
        callback(this.$util.func.uid.check(value))
      },
      checkCjzh(rule,value,callback){
        if(value.length!=20){
          return callback("请输入正确的残疾证号");
        }
        var type=value.substring(18,19);
        var level=value.substring(19,20);
        if(type>7 || level>4) {
          return callback("请输入正确的残疾证号");
        }
        return callback();
      },

      upStep(a,b,c,d){

        if(d && d=='master'){
          let members = this.blanApply.members;
          let master=this.req_yl_person;
          master.req_man_is=1;
          var flag=true;
          for (let i=0;i<members.length;i++){
            if (members[i]!==undefined && members[i].req_man_is==1){
              members[i]=master;
              flag=false;
              break;
            }
          }
          if(flag){
            this.blanApply.members.push(master);
          }
        }
        this.title_info=c;
        this.stepFlag=a;
        this.stepactive=b;
      },
      handleClose(){
        this.smDialogShow=false;
        this.$router.back()
      },
      sureClose(){
        this.smDialogShow=false;
        this.urlTo('peopleCertification');
      },
      selectApplyType(item){
        if(item==this.apply_way){
          return ;
        }
        this.apply_way=item;
        if(item==0){
          this.person_uid_disable=1;
          //0表示本人办理，则把登录信息转移过来
          this.initToLoginPersonData();

          this.isShow=true;
        }else{
          this.person_uid_disable=0;
          //表示委托办理，需要上传身份证正面、背面做识别
          this.req_yl_person.person_uid='';
          this.req_yl_person.person_name='';
          this.req_yl_person.idcard_pic_front='';
          this.req_yl_person.idcard_pic_back='';
          this.req_yl_person.user_nations_id='';
          this.req_yl_person.photo_id='';
          this.req_yl_person.mobile='';
          this.req_yl_person.user_nations='';
          this.req_yl_person.user_idcard_address='';
          this.req_yl_person.auth_person_uid=this.loginPerson.person_uid;
          this.req_yl_person.auth_person_name=this.loginPerson.person_name;
          this.req_yl_person.auth_tel=this.loginPerson.person_tel;

          this.idcard_pic_front='';
          this.idcard_pic_back='';
          this.idcard_pic_front_img='';
          this.idcard_pic_back_img='';
          this.req_yl_person.idcard_pic_front='';
          this.req_yl_person.photo_id='';
          this.req_yl_person.idcard_pic_back='';

          this.req_yl_person.mobile='';

          this.isShow=false;
          this.idcardPic=[];
          this.idcard_pic_frontArr=[];
          this.idcard_pic_backArr=[];
        }
      },
      getBankTypeData(){
        let data={
        };
        this.$https.post('api/ywt/base/getBankTypeData.do',data,response=>{
          if (response.data.code===200){
            this.bank_type=response.data.data.bankTypeList;
          }
        })
      },
      initToLoginPersonData(){

        this.req_yl_person.person_name=this.loginPerson.person_name;
        this.req_yl_person.idcard_pic_front=this.loginPerson.idcardPicFront;
        this.req_yl_person.idcard_pic_back=this.loginPerson.idcardPicBack;
        this.req_yl_person.user_nations_id=this.loginPerson.userNationsId;
        this.req_yl_person.user_nations=this.loginPerson.userNations;
        this.req_yl_person.regi_address=this.loginPerson.userIdcardAddress;
        this.req_yl_person.living_address=this.loginPerson.userIdcardAddress;
        this.req_yl_person.auth_person_uid=this.loginPerson.person_uid;
        this.req_yl_person.auth_person_name=this.loginPerson.person_name;
        this.req_yl_person.photo_id=this.loginPerson.photo_id;
        this.idcard_pic_front=this.loginPerson.idcardPicFront;
        this.idcard_pic_back=this.loginPerson.idcardPicBack;
        this.req_yl_person.idcard_pic_front=this.loginPerson.idcardPicFront;
        this.req_yl_person.idcard_pic_back=this.loginPerson.idcardPicBack;
        this.req_yl_person.photo_id=this.loginPerson.photo_id;

        this.req_yl_person.auth_tel=this.loginPerson.person_tel;
        this.req_yl_person.mobile=this.loginPerson.person_tel;
        this.req_yl_person.disability_number=this.loginPerson.person_uid;

        this.idcard_pic_frontArr=[];
        this.idcard_pic_frontArr.push(this.loginPerson.idcardPicFront);
        this.idcard_pic_backArr=[];
        this.idcard_pic_backArr.push(this.loginPerson.idcardPicBack);
        this.req_yl_person.person_uid=this.loginPerson.person_uid;
      },
      initReqManInfo(){
        this.req_yl_person.nations_type_id=this.loginPerson.userNationsId;
        this.req_yl_person.nations_type_name=this.loginPerson.userNations;
        this.req_yl_person.regi_address=this.loginPerson.userIdcardAddress;
        this.req_yl_person.living_address=this.loginPerson.userIdcardAddress;
        this.req_yl_person.photo_id=this.loginPerson.photo_id;
        // 政治面貌：
        this.req_yl_person.politics='1001';
        this.req_yl_person.politics_name='群众';
        this.req_yl_person.soical_ins_number=this.loginPerson.person_uid;
        this.req_yl_person.mobile=this.loginPerson.person_tel;

        this.req_yl_person.idcard_pic_front=this.loginPerson.idcardPicFront;
        this.req_yl_person.idcard_pic_back=this.loginPerson.idcardPicBack;

        this.idcard_pic_frontArr=[];
        this.idcard_pic_frontArr.push(this.loginPerson.idcardPicFront);
        this.idcard_pic_backArr=[];
        this.idcard_pic_backArr.push(this.loginPerson.idcardPicBack);

        this.req_yl_person.bank_account_name=this.loginPerson.person_name;
        this.req_yl_person.bank_person_uid=this.loginPerson.person_uid;

        this.req_yl_person.is_blan='1';
        this.req_yl_person.is_blan_name='是';

        this.req_yl_person.gsc_is='0';
        this.req_yl_person.marriage='23001';
        this.req_yl_person.marriage_name='未婚';

      },
      detailShow(value){
        if (value=='jjyl'){
          this.req_yl_person.service_demand=[];
          this.jjyl=true;
          this.jgyl=false;
        }else if (value=='jgyl'){
          this.req_yl_person.service_demand=[];
          this.jjyl=false;
          this.jgyl=true;
        }
      },
      initPhotos(archive_type_code,localPhotos){
        this.photos=localPhotos;
      },

      loadPersonInfo(){
        var tt=this;
        this.$https.post("api/pu/peopleUserInfo.do",{},response=>{
          if (response.status === 200 && response.data.code===200) {
            if(response.data.data.isCertification == '1'){
              tt.loginPerson.person_name=response.data.data.userName;
              tt.loginPerson.person_uid=response.data.data.userIdcard;
              tt.loginPerson.person_tel=response.data.data.userTel;
              tt.loginPerson.isCertification=response.data.data.isCertification;
              tt.loginPerson.idcardPicFront=response.data.data.idcardPicFront;
              tt.loginPerson.idcardPicBack=response.data.data.idcardPicBack;
              tt.loginPerson.userIdcardAddress=response.data.data.userIdcardAddress;
              tt.loginPerson.userNationsId=response.data.data.userNationsId;
              tt.loginPerson.userNations=response.data.data.userNations;
              tt.loginPerson.photo_id=response.data.data.idcardPhoto;
              if(tt.apply_id!=null && tt.apply_id!=''&&tt.apply_id!=undefined){
              }else{
                //初始化数据，默认本人办理
                if(tt.req_yl_person.apply_way==null || tt.req_yl_person.apply_way==''){
                  tt.apply_way=0;
                  tt.req_yl_person.apply_way=0;
                  tt.initReqManInfo();
                  tt.initToLoginPersonData();

                }
              }
            }else{
              //跳转去实名认证
              tt.smDialogShow=true;
            }
          } else {
            tt.$router.push({path:'/peopleLogin'});
          }
        });
      },
      getImg(imgId){
        var dd=this.$util.req.getshowImg(imgId);
        return dd;
      },
      afterReadOne(files){
        if(files){
          this.isShow=false;
          files.status = 'uploading';
          files.message = '上传中...';
          files.type='idcard_pic_front';
          files.attrName="ic_"+this.$util.uuid.uuid2();
          this.alertMsg='身份证人像面上传中...';
          this.alertType="warning";
          this.qxAlertFlag=true;
          this.idcard_pic_front_img='';
          this.idcard_pic_front='';
          this.compressImg(files);
          // this.afterReadFile(files);
        }
      },
      afterReadTwo(files){
        if(files) {
          this.isShow=false;
          files.status = 'uploading';
          files.message = '上传中...';
          files.type='idcard_pic_back';
          files.attrName="ic_"+this.$util.uuid.uuid2();
          this.alertMsg='身份证国徽面上传中...';
          this.alertType="warning";
          this.qxAlertFlag=true;
          this.idcard_pic_back_img='';
          this.idcard_pic_back='';
          this.compressImg(files);

          // this.afterReadFile(files);
        }
      },

      afterReadOne_m(files){
        if(files){
          // this.isShow=false;
          files.status = 'uploading';
          files.message = '上传中...';
          files.type='idcard_pic_front';
          files.attrName="ic_"+this.$util.uuid.uuid2();
          files.ss='m';//表示家庭成员信息
          this.alertMsg='身份证人像面上传中...';
          this.alertType="warning";
          this.qxAlertFlag=true;
          this.idcard_pic_front_img_jf='';
          this.idcard_pic_front_jf='';
          this.compressImg(files);
          // this.afterReadFile(files);
        }
      },
      afterReadTwo_m(files){
        if(files) {
          // this.isShow=false;
          files.ss='m';//表示家庭成员信息
          files.status = 'uploading';
          files.message = '上传中...';
          files.type='idcard_pic_back';
          files.attrName="ic_"+this.$util.uuid.uuid2();
          this.alertMsg='身份证国徽面上传中...';
          this.alertType="warning";
          this.qxAlertFlag=true;
          this.idcard_pic_back_img_jf='';
          this.idcard_pic_back_jf='';

          this.compressImg(files);

          // this.afterReadFile(files);
        }
      },
      compressImg(file) {
        var t=this;
        if(/\/(?:jpeg|png)/i.test(file.file.type)&&file.file.size>2097152) {
          this.photoCompress(file,{
            quality: 0.5
          },function (base64Codes) {
            var bl = t.convertBase64UrlToBlob(base64Codes);
            let bytes=atob(base64Codes.split(',')[1]);        //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            let ab = new ArrayBuffer(bytes.length);
            let ia = new Uint8Array(ab);
            for (let i = 0; i < bytes.length; i++) {
              ia[i] = bytes.charCodeAt(i);
            }
            let fileItem = new File([ab],new Date().getTime()+'.jpg',{type:'image/jpg'});
            if(fileItem){
              file.file=fileItem;
              t.afterReadFile(file);
            }
          })
        }else{
          this.afterReadFile(file);
        }
      },
      /**
       * @param file: 上传的图片
       * @param objCompressed：压缩后的图片规格
       * @param objDiv：容器或回调函数
       */
      photoCompress(file, objCompressed, objDiv){
        var ready=new FileReader();
        ready.readAsDataURL(file.file);
        var tt=this;
        ready.onload=function(){
          var fileResult=this.result;
          tt.canvasDataURL(fileResult,objCompressed,objDiv)
        }
      },

      canvasDataURL(path, objCompressed, callback) {
        var img = new Image();
        img.src = path;
        img.onload = function () {
          var that = this;
          //默认压缩后图片规格
          var quality = 0.5;
          var w = that.width;
          var h = that.height;
          var scale = w / h;
          //实际要求
          w = objCompressed.width || w;
          h = objCompressed.height || (w / scale);
          if(objCompressed.quality && objCompressed.quality > 0 && objCompressed.quality <= 1){
            quality = objCompressed.quality;
          }
          //生成canvas
          var canvas = document.createElement('canvas');
          var ctx = canvas.getContext('2d');
          // 创建属性节点
          var anw = document.createAttribute("width");
          anw.nodeValue = w;
          var anh = document.createAttribute("height");
          anh.nodeValue = h;
          canvas.setAttributeNode(anw);
          canvas.setAttributeNode(anh);
          ctx.drawImage(that, 0, 0, w, h);

          var base64 = canvas.toDataURL('image/jpeg', quality);
          // 回调函数返回base64的值
          callback(base64);
        }
      },

      convertBase64UrlToBlob(urlData) {
        var arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {type:mime});
      },
      afterReadFile(file){
        file.status='uploading';
        let formData = new FormData;
        formData.append('_sk','app');
        formData.append('upload',file.file);
        formData.append('type',file.type);
        formData.append('attachName',"ic_"+this.$util.uuid.uuid2());
        var ttt=this;
        this.$https.postFile('attach/upload.do',formData,(response)=>{
          if (response.status===200&&response.data.isOk){
            // file.attachId=response.data.bean.attach_id;
            if(file.type=='idcard_pic_front'){
              if(file.ss && file.ss =='m'){
                ttt.idcard_pic_front_jf=response.data.bean.attach_id;
                ttt.idcard_pic_front_img_jf=ttt.getImg(ttt.idcard_pic_front_jf);
              }else{
                ttt.idcard_pic_front=response.data.bean.attach_id;
                ttt.req_yl_person.idcard_pic_front=response.data.bean.attach_id;
                ttt.idcard_pic_front_img=ttt.getImg(ttt.idcard_pic_front);
              }
              ttt.qxAlertFlag=true;
              ttt.alertMsg='身份证人像面上传完成...';
              ttt.alertType="warning";
            }else{
              if(file.ss && file.ss =='m'){
                ttt.idcard_pic_back_jf=response.data.bean.attach_id;
                ttt.req_yl_person.idcard_pic_back=response.data.bean.attach_id;
                ttt.idcard_pic_back_img_jf=ttt.getImg(ttt.idcard_pic_back_jf);

              }else{
                ttt.idcard_pic_back = response.data.bean.attach_id;
                ttt.idcard_pic_back_img = ttt.getImg(ttt.idcard_pic_back);
              }
              ttt.qxAlertFlag=true;
              ttt.alertMsg='身份证国徽面上传完成...';
              ttt.alertType="warning";
            }
            file.status='done'
            if(file.ss && file.ss =='m') {
              ttt.uploadOver(ttt.idcard_pic_front_jf,ttt.idcard_pic_back_jf,'m');
            }else{
              ttt.uploadOver(ttt.idcard_pic_front,ttt.idcard_pic_back,'apply');
            }
          }else {
            file.status='failed';
            ttt.alertMsg='图片上传失败，请重新选择文件上传...';
            ttt.alertType="error";
          }
        });
        //重新验证表单项
        // this.$refs['photo'].resetValidation();
      },
      uploadOver(idcard_pic_front,idcard_pic_back,sources){
        if(idcard_pic_front!='' && idcard_pic_back !=''){
          this.qxAlertFlag=true;
          this.alertMsg='身份证信息识别中，请稍后......';
          this.alertType="warning";
          //上传正面照
          var ttt=this;
          this.$https.post('api/pu/getIdCardFromPic.do',{attr_id:idcard_pic_front},(response)=>{
            if (response.status===200&&response.data.code==200){
              if(response.data.data.ocr_success){
                //判断身份照背面是否合法
                ttt.$https.post('api/pu/getIdCardFromPic.do',{attr_id:idcard_pic_back},(response_back)=>{
                  if(response_back.data.data.ocr_success){
                    if(sources !='m'){
                      if(response.data.data.headImg && response.data.data.headImg !=''){
                        let bytes=atob(response.data.data.headImg);        //去掉url的头，并转换为byte
                        //处理异常,将ascii码小于0的转换为大于0
                        let ab = new ArrayBuffer(bytes.length);
                        let ia = new Uint8Array(ab);
                        for (let i = 0; i < bytes.length; i++) {
                          ia[i] = bytes.charCodeAt(i);
                        }
                        let fileItem = new File([ab],new Date().getTime()+'.jpg',{type:'image/jpg'});
                        let formData = new FormData;
                        formData.append('_sk','app');
                        formData.append('upload',fileItem);
                        formData.append('type',"FJ_1_HEADPHOTO_PIC");
                        formData.append('attachName',"head_"+this.$util.uuid.uuid2());
                        ttt.$https.postFile('attach/upload.do',formData,(responseaa)=> {
                          if (responseaa.status === 200 && responseaa.data.isOk) {
                            ttt.req_yl_person.photo_id=responseaa.data.bean.attach_id;
                            ttt.req_yl_person.photo_id=responseaa.data.bean.attach_id;
                          }
                        });
                      }
                      ttt.req_yl_person.idcard_pic_front=idcard_pic_front;
                      ttt.req_yl_person.idcard_pic_back=idcard_pic_back;

                      ttt.req_yl_person.person_name=response.data.data.person_name;
                      ttt.req_yl_person.user_nations_id=response.data.data.nations_type_id;
                      ttt.req_yl_person.user_nations=response.data.data.nation_str;
                      ttt.req_yl_person.user_idcard_address=response.data.data.reg_address;
                      ttt.req_yl_person.idcard_pic_front=idcard_pic_front;
                      ttt.req_yl_person.idcard_pic_back=idcard_pic_back;

                      // ttt.idcardPic=[];
                      // ttt.idcardPic.push(idcard_pic_front);
                      // ttt.idcardPic.push(idcard_pic_back);

                      ttt.idcard_pic_frontArr=[];
                      ttt.idcard_pic_frontArr.push(idcard_pic_front);
                      ttt.idcard_pic_backArr=[];
                      ttt.idcard_pic_backArr.push(idcard_pic_back);

                      ttt.req_yl_person.disability_number=response.data.data.person_uid;
                      ttt.req_yl_person.person_uid=response.data.data.person_uid;
                      ttt.isShow=true;
                    }else{
                      ttt.req_yl_person.guardian_idcard_pic_front=idcard_pic_front;
                      ttt.req_yl_person.guardian_idcard_pic_back=idcard_pic_back;
                      ttt.req_yl_person.guardian_person_name=response.data.data.person_name;
                      ttt.req_yl_person.guardian_person_uid=response.data.data.person_uid;

                      ttt.temp_guardian.guardian_person_name=response.data.data.person_name;
                      ttt.temp_guardian.guardian_person_uid=response.data.data.person_uid;
                      ttt.temp_guardian.guardian_idcard_pic_front=idcard_pic_front;
                      ttt.temp_guardian.guardian_idcard_pic_back=idcard_pic_back;
                      ttt.temp_guardian.idcard_pic_back_img_jf=ttt.idcard_pic_back_img_jf;
                      ttt.temp_guardian.idcard_pic_front_img_jf=ttt.idcard_pic_front_img_jf;
                      ttt.temp_guardian.idcard_pic_front_jf=idcard_pic_front;
                      ttt.temp_guardian.idcard_pic_back_jf=idcard_pic_back;
                      ttt.guardianShow=true;
                    }
                    ttt.alertMsg='';
                    ttt.alertType="success";
                    this.qxAlertFlag=false;
                  }else{
                    if(sources !='m'){
                      ttt.isShow=false;
                      ttt.idcard_pic_back='';
                      ttt.idcard_pic_back_img='';
                      ttt.req_yl_person.idcard_pic_front='';
                      ttt.req_yl_person.idcard_pic_back='';
                    }else{
                      ttt.fmbackFileList=[];
                      ttt.guardianShow=false;
                      ttt.idcard_pic_back_jf='';
                      ttt.idcard_pic_back_img_jf='';
                      ttt.req_yl_person.guardian_idcard_pic_back=''
                    }
                    ttt.alertMsg='身份证国徽面识别失败，请重新上传！';
                    ttt.alertType="error";
                    this.qxAlertFlag=true;
                  }
                });
              }else{
                // fmfrontFileList:[],
                if(sources !='m'){
                  ttt.idcard_pic_front='';
                  ttt.idcard_pic_front_img='';
                  ttt.idcard_pic_back='';
                  ttt.idcard_pic_back_img='';
                  ttt.req_yl_person.idcard_pic_front='';
                  ttt.req_yl_person.idcard_pic_back='';
                  ttt.req_yl_person.person_uid='';
                  ttt.req_yl_person.person_name='';
                  ttt.req_yl_person.user_nations_id='';
                  ttt.req_yl_person.user_nations='';
                  ttt.req_yl_person.user_idcard_address='';
                  ttt.req_yl_person.idcard_pic_front='';
                  ttt.req_yl_person.idcard_pic_back='';
                  ttt.isShow=false;
                }else{
                  ttt.fmfrontFileList=[];
                  ttt.fmbackFileList=[];
                  ttt.guardianShow=false;
                  ttt.idcard_pic_back_jf='';
                  ttt.idcard_pic_back_img_jf='';
                  ttt.req_yl_person.guardian_idcard_pic_back=''

                  ttt.idcard_pic_front_jf='';
                  ttt.idcard_pic_front_img_jf='';
                  ttt.req_yl_person.guardian_idcard_pic_front=''
                }
                //身份证信息读取失败，要求重新上传
                ttt.alertMsg='身份证信息识别失败，请重新上传！';
                ttt.alertType="error";
              }
            }
          });
        }
      },
      applyNextStep(){
        if(this.idcard_pic_front=='' || this.idcard_pic_back ==''){
          this.qxAlertFlag=true;
          this.alertMsg='请上传身份证人像面、国徽面!';
          this.alertType="error";
          return false;
        }
        if(this.req_yl_person.person_name ==''){
          this.qxAlertFlag=true;
          this.alertMsg='请输入申请人名称!';
          this.alertType="error";
          return false;
        }
        if(this.req_yl_person.person_uid ==''){
          this.qxAlertFlag=true;
          this.alertMsg='请输入身份证号!';
          this.alertType="error";
          return false;
        }
        if(!this.$util.uid.validatorUid(this.req_yl_person.person_uid)){
          this.qxAlertFlag=true;
          this.alertMsg='请输入正确的身份证号!';
          this.alertType="error";
          return false;
        }
        if(!this.req_yl_person.party_id || this.req_yl_person.party_id==''){
          this.qxAlertFlag=true;
          this.alertMsg='请选择户籍区划!';
          this.alertType="error";
          return false;
        }
        if(!this.slPartIdArr || this.slPartIdArr.length<=2){
          this.qxAlertFlag=true;
          this.alertMsg='请选择户籍区划!';
          this.alertType="error";
          return false;
        }
        if(this.editFlag){
          // this.$router.push({path:'/clpInfo'});
          this.title_info="提交基本信息",
            this.qxAlertFlag=false;
          this.alertMsg='';
          this.alertType="";
          this.stepFlag='reqManInfo';
          this.stepactive=0;
          this.loadImg=true;
        }else {
          this.qxAlertFlag = false;
          this.alertMsg = '';
          this.alertType = "";
          /*        //校验本人是否能申请

                  var loading = this.$loading({
                    lock: true,
                    text: '数据预校验中，请稍后!',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                  });
        */
          this.initFlag = this.initFlag + 1;
          var ttt = this;
          /*          this.$https.post('api/ywt/apply/doPreCheck.do',{person_uid:this.req_yl_person.person_uid,archive_type_code:this.archive_type_code,apply_id:this.apply_id},(response)=>{
                      loading.close();
                      if (response.status===200&&response.data.code==200){
                        // this.$router.push({path:'/clpInfo'});*/
          ttt.title_info = "提交基本信息",
            ttt.qxAlertFlag = false;
          ttt.alertMsg = '';
          ttt.alertType = "";
          ttt.stepFlag = 'reqManInfo';
          ttt.stepactive = 0;
          ttt.loadImg = true;
          /*    }else{
                ttt.$dialog.alert({title:'预校验失败',message:response.data.msg});

              }
            });*/
        }

      }
      ,
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleClick(){},
      reloadPage(){
        this.reload();
      },
      loadEnjoyTreat(){
        this.$https.post("api/zj/getEnjoyTreat.do",{person_uid:this.req_yl_person.person_uid},response=>{
          if (response.status === 200 && response.data.code===200) {
            this.enjoy_treat=response.data.data.enjoy_treat;
          } else {
            // this.$toast.fail(response.data.msg)
          }
        });
      },
      getPartyId(a){
        if(this.party_id){
          return;
        }
        return;
        // if(a){
        //   this.party_id=a;
        //   // this.reload();
        //   var areaInfo=this.$cookies.get('areaInfo')
        //   if(areaInfo && areaInfo.departyId && areaInfo.departyId !=''){
        //     if(areaInfo.provinceId){
        //       this.selectedRegion[0]=areaInfo.provinceId;
        //     }
        //     if(areaInfo.cityId){
        //       this.selectedRegion[1]=areaInfo.cityId;
        //     }
        //     if(areaInfo.areaId){
        //       this.selectedRegion[2]=areaInfo.areaId;
        //     }
        //     if(this.selectedRegion.length>0){
        //       this.getDepartAreas(this.selectedRegion[this.selectedRegion.length-1],0);
        //     }
        //     if(areaInfo.departyId){
        //       // this.selecteddepartOption[0]=areaInfo.departyId
        //       this.req_yl_person.to_party_id=areaInfo.departyId;
        //       this.req_yl_person.party_id=areaInfo.departyId;
        //       // if(this.getPartyId){
        //       //   this.getPartyId(areaInfo.departyId);
        //       // }
        //     }
        //     // this.areaName=_userAreaName;
        //   }
        // }
      },

      getDepartAreas(ParentId,index){
        const options={pid:ParentId}
        var t=this;
        this.$https.post("api/pu/getPartyByParentAreaCode.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            t.departOption = Object.values(response.data.data).map(function(e){
              return {label:e.name,value:e.code,leaf:true}
            })
          } else {
            t.departOption =[];
          }
        })
      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      getDisData(){
        let data={
        };
        var tt=this;
        this.$https.post('api/ywt/base/getDisData.do',data,response=>{
          if (response.data.code===200){
            tt.dis_type=response.data.data.disTypeList;
            tt.dis_level=response.data.data.disLevelList;
          }
        })
      },
      getDictData(){
        let data={
          types:['nations_type','relation','marital_status','political_status','regi_kind',
            'education_levels','work_capacity','party_nature_type','health','serious_name','bank_card_type','open_document_type',
            'person_type','viability','org_care_service','home_care_service','person_types','chronic_disease','major_diseases',
            'medical_payment','mental_illness','dementia_status','person_class','disease'],
          archive_type_code:this.archive_type_code
        };
        this.$https.post('api/ywt/base/getDictDataNoWu.do',data,response=>{
          if (response.data.code===200){
            this.$util.readData(response.data.data,this)
          }
        })
      },
      editMember(member,index){
        member.__index=index;
        this.blanApply.currMember=member;
        var idcard_pic_front=this.blanApply.currMember.idcard_pic_front;
        var idcard_pic_back=this.blanApply.currMember.idcard_pic_back;
        if(idcard_pic_front && idcard_pic_front!=''){
          var imgUrl=this.getImg(idcard_pic_front);
          this.blanApply.currMember.idcard_pic_front_img=imgUrl;
          // console.log(this.user_idcard_one_file)
        }
        if(idcard_pic_back && idcard_pic_back!=''){
          var imgUrl=this.getImg(idcard_pic_back);
          this.blanApply.currMember.idcard_pic_back_img=imgUrl;
        }
        this.blanApply.currMember.isShow=true;
        this.familyUserDialog=true;
      },
      addMember(){
        this.blanApply.currMember={},
          this.blanApply.currMember={
            politics:'1001',
            politics_name:'群众',
            income_wages:0,
            income_pension:0,
            income_odd_job:0,
            income_unemployment_insurance:0,
            income_living_expenses:0,
            income_rent:0,
            income_operating:0,
            income_alimony:0,
            income_raise:0,
            income_other:0,
            marriage:'23001',
            marriage_name:'未婚',
            idcard_pic_front:'',
            idcard_pic_back:'',
            idcard_pic_front_img:'',
            idcard_pic_back_img:'',
            isShow:false,
          };
        this.familyUserDialog=true;
      },
      delMember(index,member){
        this.$dialog.confirm({title:'提示',message:'确定删除吗?',confirmButtonColor:'red'})
          .then(() => {
            this.blanApply.members.splice(index,1)
          })
          .catch(() => {

          });

      },
      saveMember(){
        if(this.blanApply.currMember.__index==undefined){
          this.blanApply.members.push(this.blanApply.currMember)
        }else{
          let currMember=this.blanApply.currMember;
          this.blanApply.members.map(function (m){
            if(m.__index==currMember.__index){
              return currMember;
            }else{
              return m;
            }
          });
        }
        this.familyUserDialog=false
      },
      onSave(){
        this.req_yl_person.apply_status=0;
        this.is_submit=false;
        this.save();
      },
      onSubmit(){
        var tt=this
        this.req_yl_person.apply_status=10;
        this.is_submit=true;
        tt.$refs['reqManInfo_ruleForm'].validate((valid) => {
          if (valid) {
            if (this.req_yl_person.service_demand.length > 0) {

            } else {
              this.$message.error('请选择服务需求类型！');
              return;
            }
            if (this.req_yl_person.service_demand_type ==0) {
              this.$message.error('请选择服务需求类型！');
              return;
            }
          } else {
            this.$alert("您有必填项未完善，请完善后再继续下一步!", "提示", {
              confirmButtonText: '确定'
            });
            return;
          }
          this.save();
        });

      },
      save(){
        //保存数据，并进入下一个页面,保存数据后初始化store数据
        var loading = this.$loading({
          lock: true,
          text: '数据提交中,请耐心等待....',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var tt=this;

        let data = {};
        data = this.req_yl_person;
        var tt = this;

        this.$https.post('api/ywt/apply/saveYlNeed.do', data, (response) => {
          if (response.data.code !== 200) {
            loading.close();
            tt.$alert(response.data.msg, "【" + tt.nav_name + "】" + (tt.is_submit ? "提交失败！" : "保存失败！"), {
              confirmButtonText: '确定'
            });
          } else {
            loading.close();
            tt.apply_id = response.data.data.apply_id
            tt.req_yl_person.apply_id = response.data.data.apply_id
            if (tt.is_submit) {
              tt.$alert('您可以通过:【个人中心->我的办件】查看进度', "【" + tt.nav_name + "】提交成功", {
                confirmButtonText: '确定'
              }).then(() => {
                tt.$router.push('ylNeed_cardMaking');
              }).catch(() => {
                tt.$router.push('ylNeed_cardMaking');
              });
            } else {
              tt.$alert('您的' + "【" + tt.nav_name + "】" + '信息保存成功', '您可以在【我的-我的办件】查看草稿信息', {
                confirmButtonText: '确定'
              }).then(() => {
                tt.$router.push('ylNeed_cardMaking');
              }).catch(() => {
                tt.$router.push('ylNeed_cardMaking');
              });
            }

          }
        });

      },
      party_ids(nv){
        //根据partyID,获取上级信息，并返回
        var tt=this;
        this.$https.post("api/pu/getPuUserAreaByPartyId.do",{partyId:nv},(response)=>{
          if (response.status === 200 && response.data.code==200 && response.data.data){
            var dd=response.data.data.departyId;
            tt.first_area_id=dd[0];
            dd.splice(0,1);
            tt.selectedRegion=dd;
            let cs=tt.$refs['cs2'];
            cs.panel.activePath=[];
            cs.panel.loadCount=0;
            cs.panel.lazyLoad();
            // if(response.data.data.departyId && response.data.data.departyId.length>0){
            //   tt.req_yl_person.to_party_id=response.data.data.departyId;
            //   tt.req_yl_person.party_id=response.data.data.departyId;
            // }
          }
        });
      },


    }
  }



</script>
<style>
  ._div_botton_border{
    border-bottom: 1px solid #ebedf0;
  }
  ._div_flex{
    display: -webkit-flex; /* Safari */
    display: flex;
    flex-direction: row;
  }
  ._div_width{
    width: 100%;
  }
  ._div_height{
    line-height: 26px;
  }
  ._form_title{
    width: 30%;

  }
  ._form_value{
    width: 70%;

  }
  ._title_div{
    height: 30px;
    line-height: 30px;
    font-size: 14px;

  }
  ._content_div{
    font-size: 14px;
    line-height: 30px;
  }
  .stepDivCss .el-step__description {
    padding-right: 10%;
    margin-top: -5px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 20px;
    color:#85888e;
  }
  .stepDivCss .el-step__title {
    font-size: 14px;
    line-height: 38px;
    font-weight: 600;
    color: #303133;
  }
  .popup2-box .el-rate__icon {
    font-size: 30px;
    margin-right:0px;
    color: #C0C4CC;
    -webkit-transition: .3s;
    transition: .3s;
  }
  .popup2-box .el-rate__text {
    font-size: 14px;
    vertical-align: middle;
    margin-left: 10px;
  }
  .guide_right2_star .el-rate__icon {
    font-size: 30px;
    margin-right:0px;
    color: #C0C4CC;
    -webkit-transition: .3s;
    transition: .3s;
  }

  .dialog_css .el-dialog__body {
    padding: 0;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
  .dialog_css .el-dialog__header {
    padding: 0px;
  }
  .dialog_css .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 20px;
    font-weight: 900;
  }

  .advice_tab_new22 td {
    padding-bottom: 0px;
  }
  .advice_tab_new22 .el-select{
    margin-left: 0px;
  }
  .advice_tab_new22{margin:0px auto; font-size:14px;}
  .advice_tab_new22 td span{padding-right:10px;}
  .advice_tab_new22 td span img{position:relative; top:2px; margin-right:1px;}
  .advice_tab_new22 textarea{height:102px;width:97%; padding:0px 1.5%;border:1px solid #dbdbdb; padding-top:10px; line-height:26px; font-family:"微软雅黑";}
  .advice_tab_new22 td.enclosuer{}
  .advice_tab_new22 td.enclosuer a{margin-right:20px;}
  /*.advice_tab_new input{*/
  /*width: 250px;*/
  /*}*/
  /*.advice_tab_new select{*/
  /*width: 250px;*/
  /*}*/
  .safe .el-alert__title {
    float: left;
    width: 100%;
    text-align: right;
    font-size: 13px;
    line-height: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/bizApplyQh/YlNeedEvaluation.vue